import { useSelectorKiosk } from "./useSelectorKiosk";

const useConfiguration = () => {
    const selector = useSelectorKiosk(state => state.configuration)
    return selector;
}

export default useConfiguration;